<template>
  <v-container fluid class="pa-2">
<!--    <div v-if="isLoading" class="d-flex justify-center my-3">
      <v-progress-circular
          color="primary"
          indeterminate
          size="64"
      ></v-progress-circular>
    </div>-->      

    <!-- BIO AGE -->
    <div class="d-flex flex-wrap align-stretch ma-0 pa-0">
      <!-- FIRST Column -->
      <div class="col-12 col-lg-3 ma-0 pa-2">
        <v-card
            height="100%"
            flat
            color="transparent"
            class="rounded-lg"
        >
          <v-card-title class="pb-0 text-break"><strong>{{ $t('cards.texts.bioAgeTitle') }}</strong></v-card-title>
          <v-card-text class="py-0">
            <div>{{ $t('cards.texts.bioAgeDescription') }}</div>
          </v-card-text>
        </v-card>
      </div>

      <!-- SECOND Column -->
      <div class="col-12 col-lg-9 ma-0 pa-2">
        <v-card
            height="100%"
            flat
            class="d-flex flex-column rounded-lg"
        >
          <v-card-text v-if="isLoading" class="d-flex justify-center align-center">
            <v-progress-circular
                color="primary"
                indeterminate
                size="64"
                class="my-3"
            ></v-progress-circular>
          </v-card-text>
          <v-card-text class="d-flex flex-wrap ma-0 pa-2" v-if="!isLoading">
            <!-- WEARABLES -->
            <div class="d-flex flex-wrap col-12 ma-0 pa-0 align-stretch">
              <div class="col-12 col-md-4 pa-2">
                <div><strong>{{ $t('cards.texts.wearablesTitle') }}</strong></div>
                <div>{{ $t('cards.texts.wearablesDescription') }}</div>
              </div>
              <div class="hidden-sm-and-down col-1 pa-2 d-flex justify-center"><v-divider vertical></v-divider></div>
              <div class="col-12 col-md-4 pa-2">
                <div>
                  {{ profile.wefitterConnected ? $t('cards.texts.wefitterConnected') : $t('cards.texts.wefitterNotConnected') }}
                </div>
              </div>
              <div class="hidden-sm-and-down col-1 pa-2 d-flex justify-center"><v-divider vertical></v-divider></div>
              <div class="col-12 col-md-2 pa-2 d-flex justify-end align-center">
                <div class="px-1">
                  <v-btn
                      outlined
                      icon
                      small
                      color="primary"
                      @click.prevent="showDisclaimerDialog = true"
                  >
                    <v-icon small>fal fa-info</v-icon>
                  </v-btn>
                </div>
                <div class="px-1">
                  <v-btn
                      depressed
                      color="primary"
                      class="rounded-lg"
                      @click.prevent="navigate('/connections/wearables')"
                  >
                    {{ $t('buttons.manage') }}
                  </v-btn>
                </div>
              </div>
            </div>
            <!-- IPHONE -->
<!--            <div class="d-flex flex-wrap col-12 ma-0 pa-0 align-stretch">
              <div class="col-12 col-md-3 pa-2">
                <div><strong>{{ $t('cards.texts.loginDetails') }}</strong></div>
                <div>{{ $t('cards.texts.loginDetailsDescription') }}</div>
              </div>
              <div class="hidden-sm-and-down col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-12 col-md-6 pa-2" v-html="$t('cards.texts.vimeoLogin', { email: 'mail' })">
              </div>
              <div class="hidden-sm-and-down col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-12 col-md-1 py-2 px-0 d-flex justify-end">
                <div class="px-1">
                  <v-btn
                      depressed
                      color="primary"
                      class="rounded-lg"
                      @click.prevent="navigateExternal('https://watch.movetohappiness.com/forgot_password')"
                  >
                    {{ $t('buttons.manage') }}
                  </v-btn>
                </div>
              </div>
            </div>-->
          </v-card-text>
        </v-card>
      </div>

    </div>
    
    <!-- VIEW SELECTOR-->
    <div class="d-flex flex-wrap align-stretch justify-end pa-2">
      <v-btn-toggle v-model="selectedView" color="primary">
        <v-btn value="graph">
          <v-icon>fal fa-chart-line-up-down</v-icon>
        </v-btn>

        <v-btn value="list">
          <v-icon>fal fa-list</v-icon>
        </v-btn>
      </v-btn-toggle>
    </div>
    
    <!-- BIO AGE SECTION GRAPH -->
    <div class="d-flex flex-wrap align-stretch ma-0 pa-0" v-if="selectedView === 'graph'">
      <div class="col-12 ma-0 pa-2">
        <v-card
            height="100%"
            class="d-flex flex-column rounded-lg"
        >
          <v-card-text v-if="isLoading" class="d-flex justify-center align-center">
            <v-progress-circular
                color="primary"
                indeterminate
                size="64"
                class="my-3"
            ></v-progress-circular>
          </v-card-text>
          <v-card-text class="d-flex flex-wrap ma-0 pa-2" v-if="!isLoading">
            <apexchart
                type="line"
                width="100%"
                height="400"
                class="flex-grow-1"
                :options="bioAgeOptions"
                :series="series"
            ></apexchart>
          </v-card-text>
        </v-card>
      </div>
    </div>

    <!-- BIO AGE SECTION LIST -->
    <template v-if="selectedView === 'list'">
      <div v-for="(item, index) in bioAgeList" :key="'bio-age-' + index" class="d-flex flex-wrap align-stretch ma-0 pa-0">
        <!-- FIRST Column -->
        <div class="col-12 col-lg-3 ma-0 pa-2">
          <v-card
              height="100%"
              flat
              color="transparent"
              class="rounded-lg"
          >
            <!--          <v-card-title class="pb-0 text-break"><strong>Periode</strong></v-card-title>-->
            <v-card-text class="pb-0">
              <div>{{ $moment(item.start).format('DD/MM/YYYY') }} - {{ $moment(item.end).format('DD/MM/YYYY') }}</div>
            </v-card-text>
          </v-card>
        </div>

        <!-- SECOND Column -->
        <div class="col-12 col-lg-9 ma-0 pa-2">
          <v-card
              height="100%"
              class="d-flex flex-column rounded-lg"
          >
            <v-card-text v-if="isLoading" class="d-flex justify-center align-center">
              <v-progress-circular
                  color="primary"
                  indeterminate
                  size="64"
                  class="my-3"
              ></v-progress-circular>
            </v-card-text>
            <v-card-text class="d-flex flex-wrap ma-0 pa-2" v-if="!isLoading">
              <div class="d-flex flex-wrap col-12 ma-0 pa-0 align-stretch">
                <div class="col-12 col-md-4 pa-2 d-flex flex-column align-center justify-center">
                  <div><strong>{{ $t('labels.real-age') }}</strong></div>
                  <div class="secondary--text text-h4 font-weight-medium"><span v-if="profile.organizationSettings.birthdayType !== 'EXACT'">+- </span>{{ item.realAge }}</div>
                </div>

                <div class="hidden-sm-and-down col-1 pa-2 d-flex justify-center"><v-divider vertical></v-divider></div>

                <div class="col-12 col-md-4 pa-2 d-flex flex-column align-center justify-center">
                  <div><strong>{{ $t('labels.bio-age') }}</strong></div>
                  <div class="secondary--text text-h4 font-weight-medium">{{ Math.round(item["bio_age"]) }}</div>
                </div>

                <div class="hidden-sm-and-down col-1 pa-2 d-flex justify-center"><v-divider vertical></v-divider></div>

                <div class="col-12 col-md-2 pa-2 d-flex flex-column align-center justify-center">
                  <div v-if="item['bio_age'] < item.realAge">
                    <v-icon color="success" large>
                      fal fa-arrow-down-long
                    </v-icon>
                    <span class="success--text ml-2 font-weight-medium text-h6">{{ Math.round(((item.realAge - item['bio_age']) / item.realAge) * 100) }} %</span>
                  </div>
                  <div v-else-if="item['bio_age'] > item.realAge">
                    <v-icon color="error" large>
                      fal fa-arrow-up-long
                    </v-icon>
                    <span class="error--text ml-2 font-weight-medium text-h6">{{ Math.round(((item['bio_age'] - item.realAge) / item.realAge) * 100) }} %</span>
                  </div>
                </div>
                <!--              <div class="hidden-md-and-up col-12 pa-2"><v-divider></v-divider></div>-->
              </div>
            </v-card-text>
          </v-card>
        </div>

      </div>
    </template>

    <v-snackbar
        v-model="snack"
        :timeout="3000"
        :color="snackColor"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
            v-bind="attrs"
            icon
            @click="snack = false"
        >
          <v-icon>fal fa-xmark</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <!-- CONSENT DIALOG -->
    <m2h-consent-dialog></m2h-consent-dialog>

    <!-- DISCLAIMER DIALOG -->
    <v-dialog
        v-model="showDisclaimerDialog"
        max-width="600"
        scrollable
    >
      <v-card
          class="rounded-lg d-flex flex-column"
      >
        <v-card-title></v-card-title>
        <v-card-text class="fill-height">
          <div v-html="$t('weFitter.bioAgeDisclaimer')">
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end mt-auto">
          <v-btn
              color="primary"
              depressed
              class="rounded-lg"
              @click.prevent="showDisclaimerDialog = false"
          >
            {{ $t('buttons.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
  </v-container>

</template>

<script>
import api from "@/api/api";
import {v4 as uuidv4} from "uuid";
import VueApexCharts from 'vue-apexcharts'

export default {
  name: "m2h-we-fitter-bio-age",
  props: [],
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      isLoading: false,
      connections: [],
      snack: false,
      snackColor: '',
      snackText: '',
      connectionLoading: false,
      show: false,
      connectionWefitter: {},
      connectionWefitterLoading: false,
      profile: {},
      consentDialogIdentifier: '',
      consent: {},
      acceptConsent: false,
      errorMessage: '',
      bioAgeList: [],
      realAge: 1,
      realAgeList: [],
      bioAgeChartData: {
        labels: [],
        datasets: []
      },
      series: [],
      selectedView: 'graph',
      showDisclaimerDialog: false
    }
  },
  mounted() {
    this.$root.$on('handle-consent-dialog', (data) => {
      if (data.consentDialogIdentifier === this.consentDialogIdentifier){
        this.activateBioAge()
      }
    })
    this.fetchConnectionWefitter()
  },
  
  computed: {
    bioAgeOptions(){
      const that = this
      return {
        chart: {
          width: '100%',
          type: "line",
          stacked: false,
          sparkline: {
            enabled: false
          },
          toolbar: {
            show: true,
          },
          zoom: {
            enabled: true,
            type: 'x',
            autoScaleYaxis: false,
          }
        },
        colors: [that.$vuetify.theme.currentTheme.secondary, that.$vuetify.theme.currentTheme.primary],
        labels: this.bioAgeList.map((x) => { return that.$moment(x.start).format('DD/MM/YYYY') + " - " + that.$moment(x.end).format('DD/MM/YYYY') }),
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          offsetX: 0,
        },
        stroke: {
          curve: 'straight'
        },
        xaxis: {
          categories: that.bioAgeChartData.labels,
          labels: {
            rotate: -45
          },
          tickPlacement: 'on'
        },
        tooltip: {
          theme: 'dark',
          x: {
            show: false
          },
          y: {
            title: {
              formatter: function (value) {
                return value + ':'
              }
            },
            formatter: function(value) {
              return value
            }
          }
        },
        fill: {
          opacity: 1
        },
      }
    },
  },
  
  methods: {
    async fetchConnectionWefitter() {
      this.isLoading = true
      const that = this
      that.connectionWefitterLoading = true
      await api.connections.getWefitterStatus()
          .then((res) => {
            that.connectionWefitter = res.data
            that.connectionWefitterLoading = false
          })
      await this.fetchProfile()
      
      if (!this.connectionWefitter.wefitterBioAgeConnected){
        let constraintsPassed = this.checkConstraints()
        if (!constraintsPassed){ 
          this.snackColor = 'error'
          this.snackText = this.errorMessage
          this.snack = true
        }
        if (constraintsPassed){
          await this.checkConsentAndActivate()
        }
      }

      if (this.connectionWefitter.wefitterBioAgeConnected){
        //await api.connections.activateBioAge()
        await this.fetchBioAgeList()
      }
      
      this.isLoading = false
    },
    
    async fetchProfile() {
      const that = this
      await api.account.getProfile()
          .then((res) => {
            that.profile = res.data
          })
    },
    
    checkConstraints(){
      let label = this.profile.organizationSettings.consentLabelBioAge ?? ''
      let birthdayType = this.profile.organizationSettings.birthdayType
      let gender = this.profile.gender
      
      if (!label){
        this.errorMessage = this.$t('alerts.bio_age.notActivated')
        return false
      }
      if (birthdayType === 'EMPTY'){
        this.errorMessage = this.$t('alerts.bio_age.birthDate')
        return false
      }
      if (!gender){
        this.errorMessage = this.$t('alerts.bio_age.gender')
        return false
      }
      
      return true
    },

    async fetchBioAgeList() {
      this.realAge = this.$moment().diff(this.profile.birthDate, 'years')
      let storage = localStorage.getItem(this.profile.identifier + '.bio_age')
      if (storage) { storage = JSON.parse(storage)}
      if (!storage || this.$moment(storage.timestamp).isBefore(this.$moment().subtract(4, 'hours'))){
        let profile = await api.connections.getWefitterProfile().then((res) => { return res.data })
        if (!profile || 
            !profile.birthdate || 
            !profile.gender || 
            !['m', 'f', 'x'].includes(profile.gender.toLowerCase()) ||
            (this.profile.gender.toLowerCase() !== 'u' && this.profile.gender.toLowerCase() !== profile.gender.toLowerCase()) ||
            this.profile.birthDate !== profile.birthdate
        ){ await api.connections.activateBioAge() }
        await api.connections.getWefitterBioAgeList(this.$moment().subtract(56, 'days').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD'))
            .then((res) => {
              this.bioAgeList = res.data.sort((b, a) => { return this.$moment(a.end).unix() - this.$moment(b.end).unix() })
              let bioAgeStorage = { timestamp: this.$moment(), bioAgeList: this.bioAgeList}
              localStorage.setItem(this.profile.identifier + '.bio_age', JSON.stringify(bioAgeStorage))
            })
      } else {
        this.bioAgeList = storage.bioAgeList
      }
      let labels = []
      let data = []
      let dataRealAge = []
      this.bioAgeList.forEach((item) => {
        labels.push(this.$moment(item.start).format('DD/MM') + " - " + this.$moment(item.end).format('DD/MM'))
        data.push(Math.round(item["bio_age"]))
        dataRealAge.push(this.$moment(item.end).diff(this.profile.birthDate, 'years'))
        this.realAgeList.push(this.$moment(item.end).diff(this.profile.birthDate, 'years'))
        item.realAge = this.$moment(item.end).diff(this.profile.birthDate, 'years')
      })
      labels.reverse()
      data.reverse()
      dataRealAge.reverse()
      this.series = [
        {
          name: this.$t('labels.bio-age'),
          data: data
        },
        {
          name: this.$t('labels.real-age'),
          data: dataRealAge
        }
      ]
      this.bioAgeChartData = {
        labels: labels,
        datasets: [
          {
            label: this.$t('labels.bio-age'),
            backgroundColor: this.$vuetify.theme.currentTheme.secondary,
            data: data
          },
          {
            label: this.$t('labels.real-age'),
            backgroundColor: this.$vuetify.theme.currentTheme.primary,
            data: data
          }
        ]
      }
    },

    async checkConsent(){
      this.consent = await api.consent.getForLabel(this.profile.organizationSettings.consentLabelBioAge).then((res) => { return res.data })
      this.acceptConsent = this.consent.approved
    },

    async checkConsentAndActivate(){
      await this.checkConsent()
      if (this.acceptConsent){
        await this.activateBioAge()
      } else {
        this.consentDialogIdentifier = uuidv4();
        this.$root.$emit('open-consent-dialog', { consentDialogIdentifier: this.consentDialogIdentifier, consentLabel: this.profile.organizationSettings.consentLabelBioAge })
      }
    },
    
    async activateBioAge(){
      await api.connections.activateBioAge()
          .then(() => {
            this.fetchBioAgeList()
          })
    },

    navigate(route){
      this.$root.$emit('m2h-loader-show')
      window.location.href = route
    },
    
    navigateExternal(route){
      this.$root.$emit('m2h-loader-show')
      window.open(route, '_blank')
    }
  }
}
</script>

<style scoped>

</style>